export const environment = {
  production: false,
  apiUrl: 'https://dev.odms.pdc.app.np-nbnunify.com.au',
  //apiUrl:'http://127.0.0.1:4200',
    test:true
};